/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DistributionChannelListItem,
    DistributionChannelListItemFromJSON,
    DistributionChannelListItemFromJSONTyped,
    DistributionChannelListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface DistributionChannelListResponse
 */
export interface DistributionChannelListResponse {
    /**
     * 
     * @type {Array<DistributionChannelListItem>}
     * @memberof DistributionChannelListResponse
     */
    items?: Array<DistributionChannelListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelListResponse
     */
    totalRecords?: number;
}

export function DistributionChannelListResponseFromJSON(json: any): DistributionChannelListResponse {
    return DistributionChannelListResponseFromJSONTyped(json, false);
}

export function DistributionChannelListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(DistributionChannelListItemFromJSON)),
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function DistributionChannelListResponseToJSON(value?: DistributionChannelListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(DistributionChannelListItemToJSON)),
        'totalRecords': value.totalRecords,
    };
}


